import React from "react";
import { Calendar } from "react-calendar";
import "./CalendarCustom.scss";
import { Drawer } from "antd";

const CalendarCustom = ({
  openCalendar,
  typeCalendar,
  setValue,
  valueCalendar,
  setOpenCalendar,
  minDate,
}) => {
  const drawerStyles = {
    header: {
      display: "none",
      borderBottom: `1px solid red`,
    },
    body: {
      padding: 0,
    },
  };

  const onClose = () => {
    setOpenCalendar(false);
  };

  return (
    <Drawer
      classNames="p-0"
      title="Basic Drawer"
      placement="bottom"
      closable={false}
      onClose={onClose}
      open={openCalendar}
      styles={drawerStyles}
    >
      <div className="z-50 bg-primary calendar-custom">
        <div className="bg-white flex items-center justify-center relative py-5 px-2">
          <div className="font-semibold text-[20px]">
            {typeCalendar === "departDate"
              ? "Ngày nhận phòng"
              : "Ngày trả phòng"}
          </div>
        </div>
        <Calendar
          onChange={setValue}
          onClose
          value={valueCalendar}
          nextLabel={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="currentColor"
              className="text-primary"
            >
              <path d="m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z" />
            </svg>
          }
          prevLabel={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="currentColor"
              className="text-primary"
            >
              <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
            </svg>
          }
          next2Label={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="currentColor"
              className="text-primary"
            >
              <path d="M383-480 200-664l56-56 240 240-240 240-56-56 183-184Zm264 0L464-664l56-56 240 240-240 240-56-56 183-184Z" />
            </svg>
          }
          prev2Label={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="currentColor"
              className="text-primary"
            >
              <path d="M440-240 200-480l240-240 56 56-183 184 183 184-56 56Zm264 0L464-480l240-240 56 56-183 184 183 184-56 56Z" />
            </svg>
          }
          minDate={minDate}
          locale="vi"
        />
      </div>
    </Drawer>
  );
};

export default CalendarCustom;
